import ColorPicker from '@components/ColorPicker';
import { Dropdown } from '@components/Dropdown';
import WidgetRow from '@components/PlayerWidgets/WidgetRow';
import WidgetRowAlign from '@components/PlayerWidgets/WidgetRowAlign';
import { fontSizeItems } from '@components/PlayerWidgets/WidgetRowFont/WidgetRowFont';
import { WidgetRowWrittingMode } from '@components/PlayerWidgets/WidgetRowWrittingMode';
import { MARKER_TITLE_DEFAULT } from '@modules/sandTable/constants';
import { isMapMarkerWithTitleSetting } from '@modules/sandTable/utils/markerTypeCheck';
import { $editingMapMarkerApi } from '@stores/editingMarkerStores';
import type { HSTitleSetting } from '@types';

export function TitleTextSetting({
  titleSetting,
}: { titleSetting: HSTitleSetting }) {
  const {
    font = MARKER_TITLE_DEFAULT.font,
    writingMode = MARKER_TITLE_DEFAULT.writingMode,
    align = MARKER_TITLE_DEFAULT.align,
  } = titleSetting;

  return (
    <>
      <WidgetRow>
        <div className="mb-10">字号：</div>
        <Dropdown
          items={fontSizeItems}
          selected={font.fontSize}
          onChange={(val) => {
            $editingMapMarkerApi.update((draft) => {
              if (isMapMarkerWithTitleSetting(draft)) {
                draft.titleSetting.font.fontSize = val;
              }
            });
          }}
        />
        <ColorPicker
          className="mt-20"
          colorString={font.fontColor}
          onChange={(colorString) => {
            $editingMapMarkerApi.update((draft) => {
              if (isMapMarkerWithTitleSetting(draft)) {
                draft.titleSetting.font.fontColor = colorString;
              }
            });
          }}
        >
          <ColorPicker.Header>字体颜色：</ColorPicker.Header>
          <ColorPicker.Bar />
        </ColorPicker>
      </WidgetRow>
      <WidgetRowWrittingMode
        value={writingMode}
        onChange={(val) => {
          $editingMapMarkerApi.update((draft) => {
            if (isMapMarkerWithTitleSetting(draft)) {
              draft.titleSetting.writingMode = val;
            }
          });
        }}
      />
      <WidgetRowAlign
        value={align}
        vertical={writingMode === 1}
        onChange={(val) => {
          $editingMapMarkerApi.update((draft) => {
            if (isMapMarkerWithTitleSetting(draft)) {
              draft.titleSetting.align = val;
            }
          });
        }}
      />
    </>
  );
}
